import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import CloseIcon from '@mui/icons-material/Close';
import ShareIcon from '@mui/icons-material/Share';
import React, { useState } from 'react';
import PostSocialShares from './PostSocialShares';

const SocialShareDialog = props => {
  const [open, setOpen] = useState(false);

  const {
    author,
    permlink,
    tags,
    title,
    thumbnail,
    setListenClickAway,
    isCommentMode,
  } = props;
  let tagString = '';
  if (tags)
    tags.forEach((t, i) => {
      if (i > 0) tagString += ', ';
      tagString += `#${t}`;
    });

  const handleOpen = () => {
    if (navigator.share)
      navigator.share({
        title,
        text: `${title} ${tagString}`,
        url: window.location.href,
      });
    else {
      setListenClickAway(false);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setListenClickAway(true);
    setOpen(false);
  };

  return (
    <>
      <MenuItem onClick={handleOpen}>
        <ListItemIcon>
          <ShareIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Share" />
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-center" id="form-dialog-title">
          Share
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              padding: '2px',
            }}
          >
            <IconButton onClick={handleClose} aria-label="Close" size="large">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <PostSocialShares
            isCommentMode={isCommentMode}
            author={author}
            permlink={permlink}
            tags={tags}
            title={title}
            thumbnail={thumbnail}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SocialShareDialog;
